import { render, staticRenderFns } from "./AddEditUser.vue?vue&type=template&id=1c835c40"
import script from "./AddEditUser.vue?vue&type=script&lang=js"
export * from "./AddEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports